export const isProd = () => process.env.NODE_ENV == 'production';

// 线上环境域名是 user.arcsite.com 或者 user.arcsiteapp.com
const ONLINE_HOSTS = [
  'user.arcsite.com',
  'user.arcsiteapp.com',
  'loginas.arcsite.com',
];
export const isOnline = () => {
  const host = window.location.host;
  return ONLINE_HOSTS.includes(host);
};

export const isDev = () => {
  return process.env.NODE_ENV == 'development';
};

export const getEnterpriseHost = () => {
  return isDev()
    ? 'http://localhost:5173'
    : isOnline()
      ? 'https://enterprise.arcsite.com'
      : 'https://hq-test.arcsite.com';
};
